import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $trigger: this.el._$('.video-trigger'),
      $video: this.el._$('.video'),
      $iframe: this.el._$('.video__iframe'),
      $iframeWrapper: this.el._$('.video__iframe-wrapper')
    }
    this.videoSrc = this.dom.$iframe.getAttribute('src').trim()
    this.isWistia = this.videoSrc.includes('wistia')
    this.dom.$iframeWrapper.style.opacity = '0';
    this.dom.$iframeWrapper.style.transitionDuration = '0.5s';
    this.dom.$iframeWrapper.style.transitionProperty = 'opacity';

    this.iframeVisible = false;
  }

  addListeners() {
    this.dom.$video.addEventListener('modalopen', this.openVideo.bind(this));
    this.dom.$video.addEventListener('modalclose', this.closeVideo.bind(this));

    this.dom.$iframe.addEventListener('load', this.handleModal.bind(this));
  }

  openVideo(){
    this.iframeVisible = true;
    if (this.isWistia) this.dom.$iframe.setAttribute('src', `${this.videoSrc}?autoPlay=true&muted=true`)
    else this.dom.$iframe.setAttribute('src', `${this.videoSrc}?autoplay=1&mute=1`)
  }

  handleModal(){
    if (this.iframeVisible) this.dom.$iframeWrapper.style.opacity = '1';
    else this.dom.$iframeWrapper.style.opacity = '0'
  }

  closeVideo(){
    this.iframeVisible = false;
    this.dom.$iframe.removeAttribute('src')
  }
}

export default Module;
